package fr.frux.core.designsystem.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import fr.frux.core.designsystem.theme.FruxSpacing

private val HandleWidth = 32.dp
private val HandleHeight = 4.dp

/**
 * Poignée décorative commune à toutes les feuilles (sheets custom du slot carte et
 * `ModalBottomSheet` natifs). Purement visuelle : aucun `clickable`, aucun ripple — le
 * `dragHandle` par défaut de Material3 1.9 enveloppe la poignée d'un `Box(Modifier.clickable)`
 * qui la rend cliquable avec effet, incohérent avec les feuilles custom. Les `ModalBottomSheet`
 * doivent donc passer `dragHandle = null` et poser cette poignée en tête de leur contenu
 * (fermeture toujours possible au scrim, au geste et au retour système).
 *
 * [modifier] s'applique à la bande pleine largeur (cible de drag confortable pour les feuilles
 * qui branchent un geste dessus), pas au pictogramme.
 */
@Composable
fun FruxDragHandle(modifier: Modifier = Modifier) {
    Box(
        modifier =
            Modifier
                .fillMaxWidth()
                .padding(vertical = FruxSpacing.sm)
                .then(modifier),
        contentAlignment = Alignment.Center,
    ) {
        Box(
            modifier =
                Modifier
                    .size(width = HandleWidth, height = HandleHeight)
                    .background(
                        color = MaterialTheme.colorScheme.onSurfaceVariant.copy(alpha = 0.3f),
                        shape = RoundedCornerShape(50),
                    ),
        )
    }
}
